import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  button.cashout_all {
    border-radius: 10px;
    padding: 8px 14px;
    font-size: 0.7rem;
    white-space: nowrap;
    text-transform: uppercase;
    line-height: 100%;
    display: flex;
    margin: 0 0 0 15px;
    background: hsla(0, 0%, 100%, 0.05);
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    height: fit-content;
    display: flex;
    justify_content: center;
    align-items: center;
    flex-direction: row;
    font-weight: 600;
  }

  button.cashout_all .pandl_cashoutall_ind {
    margin: 0 0 0 5px;
    /* color: hsl(220, 4%, 70%); */
    line-height: 100%;
    position: relative;
  }
  button.cashout_all.profit {
    background: linear-gradient(180deg, #153a1b, #14381a, #143719, #133518, #133318, #123117, #123016, #112e15);
    border: 1px solid hsla(126, 100%, 28%, 0.3);
    color: #fff;
  }

  button.cashout_all.profit .pandl_cashoutall_ind span {
    color: hsla(126, 100%, 38%, 1);
  }

  button.cashout_all.loss {
    background: linear-gradient(180deg, #53182b, #4f1729, #4c1627, #481525, #451424, #411322, #3d1220, #3a111e);
    border: 1px solid hsla(340, 88%, 46%, 0.3);
    color: #fff;
  }

  button.cashout_all.neutral {
    filter: grayscale(1);
    opacity: 0.5;
  }

  button.cashout_all.disabled {
    filter: grayscale(1);
    opacity: 0.5;
    cursor: not-allowed;
  }

  button.cashout_all.loss .pandl_cashoutall_ind span {
    color: hsla(340, 88%, 46%, 1);
  }
  @media (max-width: 600px) {
    button.cashout_all {
      margin: 0 5px 0 5px;
    }
  }
`

export const CashOutAllCSS = styled.div`
  ${designerCSS}
`
